class CookieBar {
  constructor() {
    this.cookiesBar = document.getElementById('cookies-bar');
  }

  init() {


    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('****** COOKIES init ****')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')

    if (this.cookiesAllowed()) {
      this.appendGACode();
      console.log('****** COOKIES ARE ALLOWED ****')
    } else {
      console.log('****** COOKIES ARE NOT ALLOWED ****')
    }

    this.addButtonBehaviors();


  }

  cookiesAllowed() {
    return Cookies.get('allow_cookies') === 'yes';
  }

  addButtonBehaviors() {
    if (!this.cookiesBar) {
      return;
    }

    this.cookiesBar.querySelector('.accept').addEventListener('click', () => this.allowCookies(true));

    this.cookiesBar.querySelector('.reject').addEventListener('click', () => this.allowCookies(false));
  }

  appendGACode() {
    console.log('****** APPEND GA CODE ****')

    const ga = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){" +
      "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o)," +
      "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)" +
      "})(window,document,'script','//www.google-analytics.com/analytics.js','ga');" +
      "ga('create', 'UA-290966269-Y', 'auto');" + "ga('send', 'pageview');";

    document.getElementsByTagName('head')[0].append('<script>' + ga + '</script>');

    //
    // var _gaq = _gaq || [];
    // _gaq.push(['_setAccount', 'UA-290966269-Y']);
    // _gaq.push(['_trackPageview']);
    //
    // var loadGoogleAnalytics = function(){
    //   var ga = document.createElement('script');
    //   ga.type = 'text/javascript';
    //   ga.async = true;
    //   ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
    //
    //   // var s = document.getElementsByTagName('script')[0];
    //   // s.parentNode.insertBefore(ga, s);
    //
    //   document.getElementsByTagName('head')[0].append('<script>' + ga + '</script>');
    // }

  }

  allowCookies(allow) {

    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('****** COOKIES CLICK ****')
    console.log(allow)
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')
    console.log('*************************')

    if (allow) {
      Cookies.set('allow_cookies', 'yes', {
        expires: 365
      });

      this.appendGACode();
    } else {
      Cookies.set('allow_cookies', 'no', {
        expires: 365
      });
    }

    this.cookiesBar.classList.add('hidden');
  }
}

window.onload = function() {
  const cookieBar = new CookieBar();

  cookieBar.init();
}
